













import Vue from "vue";
import { WordSelectOption } from "@tt-app/types";

interface Data {
  filled: boolean;
}

interface Methods {
  optionClickHandler: (option: WordSelectOption, index: number) => void;
}

interface Computed {
  selectionIndexes: (number | undefined)[];
}

interface Props {
  blankId: number;
  options: WordSelectOption[];
  selections: {
    [key: number]: {
      index: number;
      option: WordSelectOption;
    }[];
  };
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "WordSelectOptions",
  props: {
    blankId: {
      type: Number,
      default: 0
    },
    options: {
      type: Array,
      required: true
    },
    selections: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      filled: false
    };
  },
  computed: {
    selectionIndexes() {
      const selections = this.selections[this.blankId];

      if (!selections) return [];

      return this.selections[this.blankId].map(selection => {
        if (!selection) return;
        return selection.index;
      });
    }
  },
  methods: {
    optionClickHandler(option, index) {
      if (!this.selectionIndexes.includes(index)) {
        if (!this.filled) {
          this.$emit("word-selected", { option, index }, this.blankId);
        }
      } else {
        this.$emit("word-deselected", { id: this.blankId, option, index });
      }
    }
  },
  watch: {
    selections(newSelections) {
      if (this.blankId) {
        this.filled = newSelections[this.blankId][0] !== undefined;
      }
    }
  }
});
